/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Base64 } from 'js-base64'
import Switch from 'react-switch'

import { CircularProgress } from '@material-ui/core'
import { FiCheck, FiClock } from 'react-icons/fi'

import usePersistedState from '../../hooks/usePersistedState'
import { formatValue } from '../../utils/formatValues'
import calculaIdade from '../../utils/calculaIdade'
import api from '../../services/api'

import ModalBox from '../../components/Modal'
import Button from '../../components/Button'
import Header from '../../components/Header'

import {
  Container,
  Content,
  BtnVoltar,
  InfoContent,
  Participants,
  Confirmation,
  Line,
} from './styles'
import {
  ConfigData,
  UserData,
  UserDetails,
  Participant,
  ErroProps,
} from '../../utils/interfaces'

const Conclusion: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)
  const [configData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [userDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )

  const [selectedReceive] = usePersistedState<'PD' | 'PS' | 'VF' | null>(
    'receiveTypeSelected',
    'PD',
  )
  const [timeValueYears] = usePersistedState<number>('TimeValueYears', 5)
  const [percentualValuePercent] = usePersistedState<number>(
    'PercentualValuePercent',
    1,
  )
  const [percentualValueSaque] = usePersistedState<number>(
    'PercentualValueSaque',
    1,
  )
  const [rendaFixa] = usePersistedState('RendaFixaValue', 0)

  const [aguarde, setAguarde] = useState(false)
  const [timer, setTimer] = useState(0)
  const [reSend, setReSend] = useState(true)

  const [acceptTerms, setAcceptTerms] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [warningText, setWarningText] = useState('')

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  const history = useHistory()

  const handleConfirmaAdesao = useCallback(async () => {
    setAguarde(true)

    const parametros = Base64.encode(
      `{
        "token": "${configData.token}",
        "versao": "${configData.tipo}",
        "plano": "${configData.plano}",
        "nome": "${userData.name}",
        "cpf": "${userData.cpf.replaceAll('.', '').replace('-', '')}",
        "nascimento": "${userData.birthdate}",
        "email": "${userData.email}",
        "telefone": "55${userData.phone
        .replace('(', '')
        .replace(') ', '')
        .replace('-', '')}",
        "admissao":"${userData.admission}",
        "salario": "${userDetails.salario
        .toFixed(2)
        .toString()
        .replace('.', ',')}",
        "valor": "${userDetails.contribuicaoBasica
        .toFixed(2)
        .toString()
        .replace('.', ',')}",
        "pctCtbBasica": "${userDetails.pctContribuicaoBasica
        .toString()
        .replace('.', ',')}",
        "valorsuplementar": "${userDetails.contribuicaoSuplementar
        .toFixed(2)
        .toString()
        .replace('.', ',')}",
        "pctCtbSuplementar": "${userDetails.pctContribuicaoSuplementar
        .toString()
        .replace('.', ',')}",
        "pctSaque": "${percentualValueSaque}",
        "regimetributacao": "${userDetails.tributacao}",
        "idade_apos":"${userDetails.age}",
        "tempo_contribuicao": "${userDetails.years}",
        "forma_resgate": "${selectedReceive}",
        "valor_resgate": "${selectedReceive === 'PS'
        ? percentualValuePercent.toFixed(2).toString().replace('.', ',')
        : selectedReceive === 'VF'
          ? rendaFixa.toFixed(2).toString().replace('.', ',')
          : timeValueYears
      }",
        "politicamenteexposto": "${userDetails.ppe}",
        "usperson": "${userDetails.usperson}",
        "beneficiarios": [${participants.map(
        participant => `
          {"nome": "${participant.data.name}",
          "cpf": "${participant.data.cpf.replaceAll('.', '').replace('-', '')}",
          "nascimento": "${participant.data.birthdate}",
          "parentesco":"${participant.details.grauParentesco}",
          "tipo":"${participant.details.tipoBen}",
          "fator": "${participant.details.proporcao
            .toFixed(2)
            .toString()
            .replace('.', ',')}"}`,
      )}]
        }`,
    )

    const parametrosFinal = Base64.encode(parametros)

    await api
      .post(`wsAdesao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
      .then(() => {
        history.push('/end')
      })
      .catch(res => {
        if (res.message === 'Request failed with status code 401') {
          alert('Tempo de sessão expirado')
          history.push('/register')
        } else if (res.message === 'Request failed with status code 406') {
          setWarningText(
            'Adesão não autorizada. Verifique se você já possui cadastro no plano.',
          )
          setIsModalOpen(true)
          setReSend(false)
          setTimer(20)
          setAguarde(false)
        } else if (res.message === 'Network Error') {
          setErroProps({
            title: res.message,
            description: 'Falha na conexão como servidor',
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: res.message,
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 408') {
          alert('Tempo de sessão expirado')
          history.push('/register')
        } else {
          setReSend(false)
          setTimer(20)
          setAguarde(false)
          setWarningText('Ops, algo deu errado. Tente novamente mais tarde.')
          setIsModalOpen(true)
        }
      })
  }, [
    configData,
    history,
    participants,
    percentualValuePercent,
    percentualValueSaque,
    rendaFixa,
    selectedReceive,
    setErroProps,
    timeValueYears,
    userData,
    userDetails,
  ])

  const toggleAcceptTerms = useCallback(() => {
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }
    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <Confirmation>
            <p>
              Eu, {userData.name}, inscrito no CPF <b>{userData.cpf}</b>,
              declaro que ao clicar em <b>Confirmar Adesão</b> estou confirmando
              minha adesão ao <b>Plano Patrocinado Cibrius</b> e que as informações
              prestadas são verídicas.
            </p>

            <div>
              <small>
                Aceito os{' '}
                <a
                  href="https://cibrius.com.br/lgpd/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Termos de Uso
                </a>
              </small>
              <Switch
                onChange={toggleAcceptTerms}
                checked={acceptTerms}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={40}
                handleDiameter={16}
                offColor="#DEE3E1"
                offHandleColor="#fff"
                onHandleColor="#fff"
                onColor="#31D19E"
              />
            </div>
          </Confirmation>
        </Content>

        <Button
          type="button"
          color="blue"
          width="large"
          disabled={!acceptTerms || !reSend || aguarde}
          onClick={handleConfirmaAdesao}
        >
          {!aguarde ? (
            !reSend ? (
              <>
                <FiClock size={45} />
                <span>
                  Tente novamente em {timer < 10 ? `0${timer}` : timer} segundos
                </span>
              </>
            ) : (
              <>
                <FiCheck size={45} />
                <span>Confirmar adesão</span>
              </>
            )
          ) : (
            <>
              <CircularProgress color="inherit" />
              <span>Aguarde</span>
            </>
          )}
        </Button>
        <BtnVoltar type="button" onClick={() => history.goBack()}>
          &lt; Anterior
        </BtnVoltar>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          <p>{warningText}</p>
        </ModalBox>
      </Container>
    </>
  )
}

export default Conclusion
